export const buildenv = {
  deployedAt: '2023-03-22T09:01:35.982Z',
  release: 'development',
}
